<template>
  <v-container>
    <h1 class="">Il progetto di ricerca</h1>

    <div class="text-content">
      <p>
        Il progetto di ricerca EduKanji nasce nel 2012 come <i>EDUKANJI: Kanji Learning System and Lesson Manager (Alessandro Mantelli, Marcella Mariotti, 2012)</i>, grazie ai fondi del
        dipartimento di Studi sull’Asia e l’Africa Mediterranea (DSAAM)
        dell’Università Ca’ Foscari di Venezia, con lo scopo di indagare le
        possibili soluzioni didattiche e tecnologiche di supporto
        all’insegnamento dei kanji.
      </p>
      <p>
        La ricerca, incentrata sull’analisi degli strumenti preesistenti in uso ai docenti di giapponese
        di Ca’ Foscari, sulle interviste ai docenti di kanji del DSSAM e sulla raccolta dati
        sui relativi bisogni didattici degli studenti che, impossibilitati a studiare in Giappone
        per l’emergenza di Fukushima 2011, hanno via via contribuito con materiali di studio
        o tesine alla creazione del progetto e del dizionario italiano ITADICT ad esso collegato,
        ha permesso la progettazione di un case study la cui implementazione si è realizzata
        con il primo prototipo Edukanji (2012), limitato all’utilizzo tramite la rete di Ateneo.

      </p>
      <p>
        Nel 2020, a causa della situazione pandemica Covid ’19 che in Italia ha spinto i docenti
        a riorganizzare le lezioni attraverso piattaforme online, l’applicativo Moodle diventa
        il sistema di riferimento per la didattica da remoto. In considerazione di queste <b>nuove
        necessità didattiche</b>, viene realizzato un nuovo prototipo che permette una completa
        integrazione in Moodle per favorire le nuove modalità operative dei docenti
        di dipartimento: <b>EduKanji 2.0</b>, che a differenza del suo prototipo è ora finalmente
        <b>accessibile a tutti</b>.
      </p>

      <p>
        Come il suo prototipo, anche Edukanji 2.0, si basa sul corpora Kanjidic2
        dell’Electronic Dictionary Research and Development Group (2008) che comprende 13,108 kanji 
        e incorpora tutte le 11,655 forme vettoriali di KanjiVg (Apel 2009)
        permettendo in questo modo di generare le animazioni dell’88% dei kanji presenti nel database.
      </p>
      <p>
        In base ai risultati delle ricerche sulle nuove necessità didattiche relative ai kanji
        delle collaboratrici ed esperte linguistiche e dei docenti del Dipartimento di
        Studi sull’Asia e sull’Africa Mediterranea, sono state aggiunte le seguenti funzionalità:
      </p>
      <ul>
        <li>
          Nome della dispensa in uso ai docenti e pagina in cui il kanji è
          presente;
        </li>
        <li>
          Lista dei kanji con la stessa componente fonetica, quando presente;
        </li>
        <li>
          Estensione delle funzionalità di EduKanji anche per i sillabari
          hiragana e katakana;
        </li>
        <li>
          Possibilità di scaricare in PDF le scheda del kanji con le indicazioni
          della scrittura corretta del carattere e lo spazio per fare esercizio;
        </li>
        <li>
          Scheda con l’origine storica del carattere quando
          presente (collegamento con Wikimedia);
        </li>
        <li>
          Lista dei termini più frequenti in cui il kanji compare, grazie al
          collegamento col progetto A4edu (Mantelli, Mariotti 2016)
        </li>
      </ul>
      <br />
      <!--Responsabile scientifico: Alessandro Mantelli-->
      <h3><b>Sviluppi futuri della ricerca</b></h3>
      <p>
        Il progetto EduKanji è in continua evoluzione.</p>
      <p>
        In particolare, sono allo studio esercizi di kanji e composti, sviluppati attraverso
        strategie di gamification ovvero l’applicazione di <b>metafore proprie dei videogiochi
        a compiti della vita reale al fine di migliorare motivazione e aumentare il coinvolgimento degli apprendenti</b>
        (Marczeswki 2013).
      </p>
      <p>
        La teoria della gamification si basa sulle teorie della motivazione, in particolare
        su quella dell’auto determinazione di Ryan e Deci (2000), secondo la quale è possibile
        stimolare la motivazione intrinseca di un soggetto soddisfando tre bisogni psicologici:
        competenza, autonomia e relazione.
        <br>Nel caso di esercizi presenti in un sistema E-learning, tali bisogni possono essere soddisfatti,
        per esempio, attraverso sistemi di: <b>punteggi, badge e livelli</b> propri del mondo dei videogiochi,
        insieme a sistemi di chat e forum per il confronto tramite sfide.
      </p>
      <p>Sebbene manchi ancora di funzionalità di confronto e badge, una prima implementazione dimostrativa
        in EduKanji è presente nella seguente pagina:
        <a href="https://edukanji.unive.it/cardgame" target="_blank" rel="noopener noreferrer">edukanji.unive.it/cardgame<span class="sr-only"> (apre in nuova scheda)</span></a>
        (funzionalità limitata agli account di Ca'Foscari).
      </p>

      <p>EduKanji prevede inoltre, nel breve futuro, l'integrazione con i risultati dei più
        recenti progetti di dipartimento quale il dizionario giapponese-italiano 
        <b>CAFOSCARI Jisho</b> (<i>CAFOSCARI jisho app, IT and Japanese Language Collaborative Training Research Project</i>
        , Mariotti, Mantelli, Varone, Alessandrini, Garassino, 2022).
      </p>



    </div>
  </v-container>
</template>

<script>
export default {};
</script>

<style >
</style>